import React, {useState, useEffect} from "react";

export default function OverallPrimoBack({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(lightContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M366.521,231.074c-0.726-11.143-1.732-24.314-3.664-37.547c-0.76-5.2-1.268-10.49-1.754-15.606
		c-0.257-2.703-0.525-5.491-0.827-8.239c-0.235-2.145-0.67-4.307-1.094-6.396c-0.246-1.234-0.503-2.508-0.715-3.765
		c-0.927-5.474-1.916-11.037-2.927-16.539c-2.541-13.802-6.184-26.817-10.032-40.591c-0.492-1.743-0.978-3.491-1.469-5.245
		c-4.112-14.79-8.702-28.246-13.278-38.915c-1.575-3.68-3.15-7.188-4.412-10.014c-1.469-3.284-2.743-6.122-2.754-6.446h-0.128
		l0.055-0.056c-0.492-0.508-0.536-0.542-0.721-0.637c-0.083-0.044-0.212-0.106-0.497-0.302
		c-11.842-8.065-36.402-16.03-41.892-17.756c0.284-0.531-0.112-1.609-0.631-2.86c-0.107-0.245-0.195-0.463-0.257-0.625
		l-4.284-11.657c-0.765-1.849-2.374-3.189-4.296-3.592c-2.468-0.519-5.485-0.631-8.144-0.731c-0.771-0.034-1.519-0.062-2.229-0.095
		c-3.222-0.168-6.646-0.224-10.45-0.19c-4.435,0.045-10.512,0.106-15.282,0.804c-0.459,0.068-0.91,0.14-1.363,0.212l-0.53,0.084
		c-1.061,0.168-2.011,0.726-2.682,1.581l-6.127,13.975l-0.135,0.313c-0.296,0.698-0.531,1.257-0.536,1.519
		c-0.005,0.29,0.107,0.559,0.302,0.76c-27.135,8.183-39.518,14.444-45.121,18.259c-0.285,0.196-0.419,0.258-0.502,0.302
		c-0.184,0.096-0.224,0.129-0.721,0.637l0.061,0.056h-0.133c0,0.693-0.66,1.715-1.19,2.536c-0.207,0.318-0.408,0.62-0.537,0.871
		c-1.357,2.541-2.681,5.027-3.932,7.557c-2.816,5.675-4.927,11.601-7.021,17.684c-4.284,12.433-7.937,25.235-10.858,38.06
		c-0.995,4.379-2.117,8.825-3.201,13.121c-1.128,4.469-2.296,9.093-3.329,13.662c-2.882,12.763-5.183,26.185-7.044,41.038
		c-0.245,1.955-0.474,3.916-0.703,5.876c-0.436,3.726-0.888,7.574-1.441,11.35c-1.234,8.429-2.09,16.823-2.732,24.688l-0.034,0.107
		c0.006,0,0.017,0,0.022,0.006c-0.363,4.413-0.659,8.663-0.915,12.645c-0.078,0.068-0.134,0.157-0.14,0.274
		c-0.012,0.179,0.083,0.336,0.24,0.392c11.194,3.865,18.84,4.904,23.829,4.904c2.563,0,4.429-0.274,5.708-0.581
		c0.022-0.012,0.459-0.223,0.643-0.788c0.045-0.268,4.513-26.889,6.122-31.386c1.357-3.798,10.456-37.395,11.629-43.847
		c0.749-4.122,3.173-12.802,5.519-21.202c0.352-1.262,0.704-2.519,1.044-3.759c2.056,24.99,3.894,50.081,3.592,56.599
		c-0.006,0.095-0.503,9.429-0.945,13.316c-0.05,0.436-0.078,0.877-0.106,1.301c-0.045,0.743-0.095,1.508-0.257,2.24
		c-1.71,7.68-3.86,22.946-4.436,52.046c-0.173,8.954-0.419,19.679-0.681,31.029c-0.933,40.809-1.988,87.063-0.905,92.487
		c0.541,2.687,0.631,17.88,0.737,35.469c0.168,28.057,0.38,62.978,2.446,68.58l0.033,0.084l0.079,0.022
		c0.134,0.039,9.077,2.726,22.951,2.726c6.982,0,15.209-0.681,24.197-2.72c0.184,0,0.184,0,0.374-3.419
		c0.111-2.072,0.268-5.038,0.457-8.59c0.369-7.111,0.855-16.59,1.341-26.068c0.966-18.958,1.921-37.921,1.921-37.921
		c0.027-0.559,2.379-56.454,1.787-79.606c0.788-17.645,4.916-34.731,4.966-34.938c0.138-3.62,0.552-10.149,1.306-15.765h0.043
		v-0.314c0.74-5.379,1.796-9.842,3.23-9.956v0.006c2.882,0.151,4.246,17.89,4.575,25.481c-0.006,0.062-0.006,0.101-0.006,0.112
		h0.011c0.006,0.156,0.012,0.324,0.017,0.475c0.045,0.168,4.172,17.26,4.96,34.888c-0.592,23.164,1.765,79.059,1.787,79.623
		c0,0,0.955,18.957,1.921,37.915c0.486,9.478,0.972,18.958,1.341,26.068c0.19,3.552,0.346,6.518,0.464,8.59
		c0.184,3.43,0.201,3.43,0.335,3.424c9.004,2.044,17.249,2.72,24.237,2.72c13.885,0,22.822-2.681,22.957-2.72l0.084-0.028
		l0.034-0.084c2.072-5.607,2.279-40.529,2.446-68.585c0.107-17.589,0.202-32.776,0.738-35.469
		c1.083-5.424,0.028-51.673-0.905-92.481c-0.184-7.999-0.357-15.696-0.509-22.678c-0.061-2.921-0.122-5.714-0.173-8.357
		c-0.564-28.62-3.094-48.388-5.273-57.348c-0.279-1.139-0.452-2.055-0.552-2.893c-0.084-0.726-0.096-1.486-0.101-2.224
		c-0.006-0.34-0.012-0.675-0.017-1.005l-0.028-0.788c-0.083-2.492-0.167-5.072-0.145-7.608c0.017-1.229,0.045-2.53,0.106-4.212
		c0.056-1.62,0.128-3.357,0.218-5.318c0.1-2.089,0.207-4.178,0.324-6.267c0.128-2.346,0.268-4.693,0.413-7.038
		c0.151-2.553,0.313-5.105,0.48-7.652c0.179-2.703,0.357-5.407,0.542-8.105c0.19-2.798,0.386-5.591,0.587-8.389
		c0.117-1.698,0.24-3.402,0.362-5.105l0.52,1.854c2.446,8.815,4.764,17.143,5.569,21.555c1.167,6.452,10.266,40.049,11.629,43.847
		c1.609,4.497,6.072,31.118,6.128,31.414c0.179,0.537,0.614,0.748,0.67,0.771c1.263,0.301,3.111,0.57,5.659,0.57
		c4.977,0,12.629-1.033,23.839-4.904l0.128-0.045L366.521,231.074z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M166.583,223.47c-1.613,0.297-3.512,0.448-5.653,0.448c-6.882,0-15.518-1.519-25.684-4.515"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M334.884,223.327c1.618,0.261,3.003,0.359,5.144,0.31c6.88-0.155,14.913-1.689,25.008-4.914"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M224.643,21.114c5.326-0.871,30.382-4.465,54.729,0.437"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.6909,0.5183"
          d="
		M187.575,480.757c0,0,21.463,6.33,48.612,0.176"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.6909,0.5183"
          d="
		M314.779,480.757c0,0-21.581,6.33-48.73,0.176"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.5183,0.5183"
          d="
		M255.509,288.24c0.28-6.105,0.67-15.486,0.509-16.992c-0.243-2.263-3.309-3.708-4.738-3.282h-0.062
		c-1.429-0.427-4.495,1.019-4.738,3.282c-0.16,1.486,0.219,10.639,0.497,16.747"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.5183,0.5183"
          d="
		M247.811,281.852v-8.464c0-1.089,0.406-2.149,1.174-2.92c0.528-0.53,1.191-0.817,2.15-0.827"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.5183,0.5183"
          d="
		M254.661,281.926l-0.118-8.582c0-1.088-0.406-2.149-1.173-2.92c-0.528-0.53-1.191-0.817-2.15-0.827"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M192.736,181.828c0,0,51.715,4.311,116.551,0"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M192.736,190.487c0,0,51.715,4.311,116.551,0"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          points="
		201.556,204.421 200.605,244.387 205.114,249.123 236.008,249.88 240.743,245.371 241.697,205.357 	"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          points="
		199.727,204.353 198.774,244.342 198.756,245.1 199.279,245.649 203.788,250.385 204.312,250.934 205.069,250.953 235.963,251.71 
		236.72,251.729 237.27,251.206 242.006,246.696 242.556,246.173 242.574,245.415 243.528,205.402 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          x1="202.097"
          y1="209.409"
          x2="240.978"
          y2="210.361"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          points="
		301.36,204.421 302.311,244.387 297.802,249.123 266.908,249.88 262.172,245.371 261.219,205.357 	"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          points="
		303.189,204.353 304.141,244.342 304.16,245.1 303.637,245.649 299.127,250.385 298.604,250.934 297.846,250.953 266.953,251.71 
		266.195,251.729 265.645,251.206 260.91,246.696 260.36,246.173 260.341,245.415 259.388,205.402 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          x1="300.819"
          y1="209.409"
          x2="261.938"
          y2="210.361"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M196.638,32.476c0,0,13.996,46.017,22.164,154.391"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M304.988,32.476c0,0-13.996,46.017-22.164,154.391"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          x1="201.277"
          y1="234.543"
          x2="240.314"
          y2="235.235"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          x1="301.421"
          y1="234.543"
          x2="262.383"
          y2="235.235"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="216.159"
          y1="209.221"
          x2="216.174"
          y2="208.847"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="216.201"
          y1="208.199"
          x2="216.201"
          y2="208.194"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.6535,0.6485"
          x1="216.201"
          y1="208.194"
          x2="216.309"
          y2="205.583"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          points="216.309,205.583 216.324,205.208 
		216.7,205.217 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="217.422"
          y1="205.235"
          x2="217.428"
          y2="205.235"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7289,0.7228"
          x1="217.427"
          y1="205.235"
          x2="226.169"
          y2="205.447"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          points="226.169,205.447 226.544,205.456 
		226.534,205.831 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="226.518"
          y1="206.489"
          x2="226.518"
          y2="206.494"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.6636,0.658"
          x1="226.518"
          y1="206.494"
          x2="226.45"
          y2="209.146"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="226.45"
          y1="209.146"
          x2="226.441"
          y2="209.522"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="286.6"
          y1="209.221"
          x2="286.585"
          y2="208.847"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="286.558"
          y1="208.199"
          x2="286.557"
          y2="208.194"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.6535,0.6485"
          x1="286.557"
          y1="208.194"
          x2="286.45"
          y2="205.583"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          points="286.45,205.583 286.435,205.208 
		286.059,205.217 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="285.336"
          y1="205.235"
          x2="285.331"
          y2="205.235"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7289,0.7228"
          x1="285.331"
          y1="205.235"
          x2="276.59"
          y2="205.447"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          points="276.59,205.447 276.214,205.456 
		276.224,205.831 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="276.241"
          y1="206.489"
          x2="276.241"
          y2="206.494"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.6636,0.658"
          x1="276.241"
          y1="206.494"
          x2="276.308"
          y2="209.146"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="276.308"
          y1="209.146"
          x2="276.318"
          y2="209.522"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          points="
		301.95,265.566 302.531,311.33 304.609,312.99 315.926,312.99 	"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          points="
		303.067,265.552 303.641,310.787 305,311.873 315.926,311.873 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          x1="303.348"
          y1="268.119"
          x2="314.582"
          y2="268.119"
        />
        <path
          fill="#010101"
          d="M198.947,203.135l-0.184-0.006l-0.743,31.571l-0.262,10.708v0.078l6.116,6.429l33.162,0.81h0.073
		l6.429-6.122l1.011-42.395L198.947,203.135z M243.436,235.81l-0.257,10.636l-6.211,5.915l-32.933-0.81l-5.915-6.211l1-41.837
		l45.059,1.056L243.436,235.81z"
        />
        <path
          fill="#010101"
          d="M304.152,203.129l-45.6,1.072l-0.184,0.006l0.748,31.61l0.262,10.713v0.073l6.379,6.072l0.051,0.05
		l33.156-0.81h0.079l6.121-6.428L304.152,203.129z M298.879,251.551l-32.927,0.81l-6.211-5.915l-1-41.887l45.054-1.056l0.737,31.202
		l0.263,10.635L298.879,251.551z"
        />
        <path
          fill="#010101"
          d="M366.521,231.074c-0.726-11.143-1.732-24.314-3.664-37.547c-0.76-5.2-1.268-10.49-1.754-15.606
		c-0.257-2.703-0.525-5.491-0.827-8.239c-0.235-2.145-0.67-4.307-1.094-6.396c-0.246-1.234-0.503-2.508-0.715-3.765
		c-0.927-5.474-1.916-11.037-2.927-16.538c-2.541-13.802-6.184-26.817-10.032-40.591c-0.492-1.743-0.977-3.491-1.469-5.245
		c-4.112-14.79-8.702-28.246-13.278-38.915c-1.575-3.68-3.15-7.188-4.412-10.014c-1.469-3.284-2.743-6.122-2.754-6.446h-0.128
		l0.055-0.056c-0.492-0.508-0.536-0.542-0.721-0.637c-0.083-0.044-0.212-0.106-0.497-0.302
		c-11.842-8.065-36.402-16.03-41.892-17.756c0.284-0.531-0.112-1.609-0.631-2.86c-0.107-0.245-0.195-0.463-0.257-0.625
		l-4.284-11.657c-0.765-1.849-2.374-3.189-4.296-3.592c-2.468-0.519-5.485-0.631-8.144-0.731c-0.771-0.034-1.519-0.062-2.229-0.095
		c-3.222-0.168-6.646-0.224-10.45-0.19c-4.435,0.045-10.512,0.106-15.282,0.804c-0.459,0.068-0.91,0.14-1.363,0.212l-0.53,0.084
		c-1.061,0.168-2.011,0.726-2.682,1.581l-6.127,13.975l-0.135,0.313c-0.296,0.698-0.531,1.257-0.536,1.519
		c-0.005,0.29,0.107,0.559,0.302,0.76c-27.135,8.183-39.518,14.444-45.121,18.259c-0.285,0.196-0.419,0.257-0.502,0.302
		c-0.184,0.095-0.224,0.129-0.721,0.637l0.061,0.056h-0.133c0,0.693-0.66,1.715-1.19,2.536c-0.207,0.318-0.408,0.62-0.537,0.871
		c-1.357,2.541-2.681,5.027-3.932,7.557c-2.816,5.675-4.927,11.601-7.021,17.684c-4.284,12.433-7.937,25.235-10.858,38.06
		c-0.995,4.379-2.117,8.825-3.201,13.121c-1.128,4.468-2.296,9.093-3.329,13.662c-2.882,12.763-5.183,26.185-7.044,41.038
		c-0.245,1.955-0.474,3.916-0.703,5.876c-0.436,3.726-0.888,7.574-1.441,11.35c-1.234,8.429-2.09,16.823-2.732,24.688l-0.034,0.107
		c0.006,0,0.017,0,0.022,0.006c-0.363,4.413-0.659,8.663-0.915,12.645c-0.078,0.068-0.134,0.157-0.14,0.274
		c-0.012,0.179,0.083,0.336,0.24,0.392c11.194,3.865,18.84,4.904,23.829,4.904c2.563,0,4.429-0.274,5.708-0.581
		c0.022-0.012,0.459-0.223,0.643-0.788c0.045-0.268,4.513-26.889,6.122-31.386c1.357-3.798,10.456-37.395,11.629-43.847
		c0.749-4.122,3.173-12.802,5.519-21.202c0.352-1.262,0.704-2.519,1.044-3.759c2.056,24.99,3.894,50.081,3.592,56.599
		c-0.006,0.095-0.503,9.429-0.945,13.316c-0.05,0.436-0.078,0.877-0.106,1.301c-0.045,0.743-0.095,1.508-0.257,2.24
		c-1.71,7.68-3.86,22.946-4.436,52.046c-0.173,8.954-0.419,19.679-0.681,31.029c-0.933,40.809-1.988,87.063-0.905,92.487
		c0.541,2.687,0.631,17.88,0.737,35.469c0.168,28.057,0.38,62.978,2.446,68.58l0.033,0.084l0.079,0.022
		c0.134,0.039,9.077,2.726,22.951,2.726c6.982,0,15.209-0.681,24.197-2.72c0.184,0,0.184,0,0.374-3.419
		c0.111-2.072,0.268-5.038,0.457-8.59c0.369-7.111,0.855-16.59,1.341-26.068c0.966-18.958,1.921-37.921,1.921-37.921
		c0.027-0.559,2.379-56.454,1.787-79.606c0.788-17.645,4.916-34.731,4.966-34.938c0.273-7.177,1.631-25.8,4.58-26.035v0.006
		c2.882,0.151,4.246,17.89,4.575,25.481c-0.006,0.062-0.006,0.101-0.006,0.112h0.011c0.006,0.156,0.012,0.324,0.017,0.475
		c0.045,0.168,4.172,17.26,4.96,34.888c-0.592,23.164,1.765,79.059,1.787,79.623c0,0,0.955,18.957,1.921,37.915
		c0.486,9.478,0.972,18.958,1.341,26.068c0.19,3.552,0.346,6.518,0.464,8.59c0.184,3.43,0.201,3.43,0.335,3.425
		c9.004,2.044,17.249,2.72,24.237,2.72c13.885,0,22.822-2.681,22.957-2.72l0.084-0.028l0.034-0.084
		c2.072-5.607,2.279-40.529,2.446-68.585c0.107-17.589,0.202-32.776,0.738-35.469c1.083-5.424,0.028-51.673-0.905-92.481
		c-0.184-7.999-0.357-15.696-0.509-22.678c-0.061-2.921-0.122-5.714-0.173-8.357c-0.564-28.62-3.094-48.388-5.273-57.348
		c-0.279-1.139-0.452-2.055-0.552-2.893c-0.084-0.726-0.096-1.486-0.101-2.224c-0.006-0.34-0.012-0.675-0.017-1.005l-0.028-0.788
		c-0.083-2.492-0.167-5.072-0.145-7.608c0.017-1.229,0.045-2.53,0.106-4.212c0.056-1.62,0.128-3.357,0.218-5.318
		c0.1-2.089,0.207-4.178,0.324-6.267c0.128-2.346,0.268-4.692,0.413-7.038c0.151-2.553,0.313-5.105,0.48-7.652
		c0.179-2.703,0.357-5.407,0.542-8.105c0.19-2.798,0.386-5.591,0.587-8.389c0.117-1.698,0.24-3.402,0.363-5.105l0.52,1.854
		c2.446,8.815,4.764,17.143,5.569,21.555c1.167,6.452,10.266,40.049,11.629,43.847c1.609,4.497,6.072,31.118,6.128,31.414
		c0.179,0.537,0.614,0.748,0.67,0.771c1.263,0.301,3.111,0.57,5.659,0.57c4.977,0,12.629-1.033,23.839-4.904l0.128-0.045
		L366.521,231.074z M224.339,20.379l6.222-14.221c0.614-0.771,1.48-1.279,2.447-1.43l0.524-0.084
		c0.453-0.073,0.905-0.145,1.358-0.212c4.748-0.693,10.808-0.755,15.232-0.799c3.804-0.039,7.21,0.022,10.428,0.19
		c0.714,0.034,1.468,0.062,2.24,0.096c2.641,0.095,5.641,0.212,8.077,0.721c1.809,0.38,3.318,1.642,4.038,3.368l4.279,11.652
		c0.062,0.168,0.157,0.391,0.263,0.642c0.324,0.783,0.927,2.234,0.631,2.598c-0.061,0.078-0.196,0.095-0.39,0.055
		c-9.423-1.899-18.981-2.519-27.454-2.519c-13.567,0-24.353,1.592-27.341,2.078c-0.313,0.056-0.609-0.017-0.816-0.195
		c-0.161-0.14-0.245-0.335-0.245-0.553C223.836,21.551,224.149,20.82,224.339,20.379 M224.149,22.786l0.006-0.005
		c0.24,0.101,0.514,0.14,0.799,0.089c4.837-0.788,30.212-4.485,54.66,0.441c0.089,0.017,0.174,0.028,0.252,0.028
		c0.078-0.006,0.145-0.022,0.212-0.045c3.235,1.011,14.808,4.73,25.828,9.434c-1.19,4.112-14.321,51.31-22.068,153.918
		c-26.555,0.966-49.685,0.614-65.995,0.034c-7.836-103.859-21.197-150.968-22.108-154.085
		C202.711,29.74,211.939,26.456,224.149,22.786 M164.366,235.085c-0.123,0.374-0.408,0.531-0.408,0.536
		c-3.703,0.883-12.439,1.497-29.291-4.323c-0.006-0.006-0.011-0.033,0-0.045c-0.006,0-0.011,0.006-0.016,0.012l-0.04-0.179
		l0.179,0.011c0.262-3.994,0.559-8.244,0.922-12.668c9.926,2.899,18.41,4.374,25.219,4.374c2.145,0,4.095-0.145,5.653-0.419
		C165.372,229.086,164.383,234.972,164.366,235.085 M187.635,138.643c-2.345,8.406-4.77,17.098-5.524,21.231
		c-1.172,6.446-10.255,39.998-11.613,43.791c-0.848,2.368-2.479,10.803-3.848,18.338c-1.536,0.279-3.569,0.436-5.72,0.436
		c-6.792,0-15.271-1.475-25.191-4.379c0.642-7.804,1.491-16.132,2.715-24.476c0.552-3.781,1.005-7.636,1.447-11.367
		c0.229-1.955,0.457-3.916,0.704-5.87c1.854-14.841,4.155-28.252,7.037-41.004c1.028-4.563,2.195-9.183,3.324-13.651
		c1.084-4.301,2.206-8.747,3.206-13.132c2.916-12.808,6.563-25.599,10.841-38.021c2.095-6.067,4.201-11.982,7.005-17.639
		c1.251-2.525,2.569-5.01,3.926-7.552c0.123-0.229,0.319-0.531,0.519-0.844c0.413-0.636,0.899-1.39,1.129-2.061
		c0.636,3.323,3.703,19.432,6.535,36.357l0.006-0.006c0.519,5.669,2.759,30.223,4.815,55.141
		C188.518,135.476,188.077,137.057,187.635,138.643 M189.3,134.018l0.005-0.006H189.3c-2.061-24.996-4.307-49.65-4.826-55.275h0.011
		c-0.011-0.039-0.017-0.073-0.022-0.112c-0.055-0.648-0.095-1.017-0.1-1.079l-0.079,0.012c-2.999-17.857-6.205-34.508-6.445-35.748
		c0.324-0.33,0.357-0.346,0.475-0.408c0.095-0.05,0.235-0.123,0.536-0.325c3.055-2.083,8.149-4.898,16.567-8.356
		c0.989,3.391,14.271,50.495,22.08,153.94c-14.383-0.52-23.37-1.206-24.6-1.308C192.495,174.559,190.965,154.177,189.3,134.018
		 M246.246,297.565c-0.045,0.173-4.184,17.293-4.972,34.988c0.593,23.152-1.759,79.031-1.781,79.59
		c-0.039,0.737-3.653,72.451-3.91,75.702c-25.861,5.831-45.383,0.413-46.808,0c-2.023-5.798-2.229-40.485-2.397-68.379
		c-0.106-17.611-0.201-32.816-0.743-35.536c-1.078-5.385,0.028-53.639,0.911-92.409c0.263-11.356,0.503-22.08,0.681-31.034
		c0.575-29.073,2.72-44.311,4.423-51.974c0.168-0.76,0.218-1.542,0.268-2.296c0.028-0.425,0.056-0.86,0.101-1.285
		c0.446-3.899,0.944-13.238,0.95-13.333c0.055-1.29,0.033-3.296-0.056-5.877c2.306,0.179,24.817,1.888,57.521,1.888h0.564v78.914
		c-0.966-0.212-2.374,0.156-3.569,0.95c-1.251,0.838-2.017,1.955-2.145,3.145c-0.285,2.676,0.854,25.599,0.904,26.576l0.068-0.006
		C246.251,297.342,246.246,297.471,246.246,297.565 M251.184,271.224l-0.006,0.179l-0.012-0.168
		c-3.1,0.163-4.345,15.702-4.758,22.941c-0.308-6.496-0.983-21.443-0.76-23.515c0.157-1.463,1.313-2.43,1.983-2.882
		c1.162-0.771,2.57-1.128,3.425-0.872l0.028,0.006l0.15-0.006c0.86-0.256,2.268,0.101,3.424,0.872
		c0.676,0.452,1.827,1.419,1.983,2.882c0.218,2-0.403,15.997-0.727,22.806C255.462,285.953,254.194,271.38,251.184,271.224
		 M315.29,268.844c0.151,6.982,0.324,14.678,0.508,22.683c0.167,7.251,0.341,14.836,0.503,22.404H304.28l-2.686-2.145l-0.598-47.166
		H315.2C315.228,265.996,315.256,267.409,315.29,268.844 M309.855,203.219c2.173,8.942,4.698,28.682,5.262,57.269
		c0.022,1.229,0.05,2.497,0.078,3.787h-14.551l0.603,47.601v0.078l2.91,2.324h12.155c0.709,32.799,1.268,65.29,0.396,69.653
		c-0.542,2.72-0.637,17.924-0.743,35.536c-0.167,27.889-0.374,62.565-2.396,68.374c-1.458,0.424-20.946,5.815-46.791,0.006
		c-0.256-3.273-3.87-74.965-3.904-75.702c-0.028-0.559-2.38-56.437-1.788-79.601c-0.787-17.684-4.926-34.804-4.966-34.938
		c0-0.128-0.011-0.296-0.017-0.503c0.089-1.855,1.179-23.862,0.899-26.481c-0.128-1.19-0.888-2.307-2.144-3.145
		c-1.167-0.776-2.531-1.139-3.497-0.966v-78.897c17.002-0.017,36.698-0.497,57.7-1.888c-0.028,1.079-0.05,2-0.062,2.894
		c-0.027,2.541,0.062,5.122,0.146,7.619l0.028,0.788c0.006,0.33,0.011,0.664,0.017,0.994c0.006,0.749,0.016,1.525,0.106,2.268
		C309.396,201.135,309.576,202.068,309.855,203.219 M312.279,133.102c-0.207,2.838-0.408,5.676-0.608,8.513
		c-0.201,2.793-0.397,5.591-0.586,8.383c-0.184,2.704-0.364,5.407-0.542,8.105c-0.163,2.553-0.324,5.105-0.48,7.658
		c-0.146,2.346-0.279,4.692-0.414,7.043c-0.112,2.089-0.223,4.178-0.324,6.267c-0.089,1.961-0.162,3.704-0.217,5.324
		c-0.011,0.335-0.022,0.653-0.034,0.966c-8.546,0.564-16.868,0.977-24.884,1.274c7.72-102.228,20.779-149.416,22.041-153.773
		c5.944,2.548,11.702,5.374,15.869,8.216c0.307,0.202,0.446,0.274,0.536,0.325c0.123,0.061,0.151,0.078,0.475,0.408
		c-0.241,1.24-3.441,17.868-6.44,35.714l-0.073-0.039c-0.079,0.151-0.073,0.369-0.073,0.559c0,0.073,0,0.134-0.006,0.184
		l-0.028,0.369c-0.005,0.044-0.017,0.095-0.022,0.14h0.011l-1.262,15.774c-0.173,2.212-0.346,4.429-0.519,6.641
		c-0.196,2.453-0.385,4.899-0.57,7.351c-0.207,2.626-0.408,5.251-0.603,7.882c-0.213,2.753-0.419,5.502-0.62,8.256
		C312.693,127.461,312.486,130.282,312.279,133.102 M330.454,203.666c-1.357-3.793-10.445-37.345-11.618-43.791
		c-0.804-4.43-3.122-12.763-5.575-21.583l-0.788-2.837c0.056-0.776,0.112-1.547,0.168-2.324c0.206-2.821,0.413-5.641,0.625-8.462
		c0.201-2.754,0.408-5.508,0.62-8.256c0.196-2.631,0.397-5.257,0.598-7.881c0.189-2.452,0.379-4.899,0.57-7.351
		c0.173-2.212,0.346-4.429,0.525-6.642l1.274-15.902c2.854-17.07,5.948-33.285,6.529-36.324c0.319,0.878,1.168,2.771,2.636,6.055
		c1.263,2.821,2.832,6.329,4.408,10.004c4.568,10.657,9.154,24.097,13.266,38.87c0.486,1.754,0.978,3.503,1.463,5.251
		c3.848,13.763,7.49,26.771,10.026,40.557c1.011,5.496,1.993,11.06,2.921,16.533c0.218,1.262,0.475,2.541,0.726,3.776
		c0.419,2.083,0.855,4.233,1.089,6.362c0.302,2.743,0.565,5.535,0.821,8.233c0.492,5.123,0.994,10.418,1.76,15.629
		c1.172,8.038,2.005,16.059,2.636,23.61c-9.875,3.14-18.337,4.81-25.14,4.966c-2.145,0.05-4.172-0.061-5.725-0.307
		C332.912,214.356,331.298,206.017,330.454,203.666 M337.029,235.632c-0.012-0.006-0.318-0.162-0.436-0.52
		c-0.022-0.122-1.028-6.11-2.252-12.88c1.307,0.196,2.883,0.302,4.614,0.302c0.346,0,0.693-0.006,1.051-0.011
		c6.814-0.156,15.282-1.827,25.163-4.961c0.397,4.732,0.709,9.278,0.988,13.529l0.006,0.246
		C349.384,237.112,340.688,236.503,337.029,235.632"
        />
      </g>
    </svg>
  );
}
